import { Icon } from "react-icons-kit";
import { mail2 } from "react-icons-kit/icomoon/mail2";

type Props = {
  customStyle?: string;
};
const Email = ({ customStyle }: Props) => (
  <span className={customStyle}>
    <Icon icon={mail2} size={20} />
  </span>
);

export default Email;
